/**
 * Reducer to manage gift option related state
 */
import { ActionTypes as types } from '../constants'
import serverProps from '../utils/serverProps'

const { giftOption } = serverProps

const initialState = {
  giftOption: giftOption,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GIFT_OPTIONS.CHANGE_OPTION:
      const {
        data: { giftOption: newGiftOption },
      } = action
      return {
        giftOption: newGiftOption,
      }

    case types.TRANSACTION.CANCELLED_TRANSACTION:
      return initialState

    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
      return {
        giftOption: '',
      }
    default:
      return state
  }
}
